<script>
import adminTable from './mixins/adminTable'
import axios from 'axios'
export default
{
  name: 'GalleryEditor',

  mixins: [ adminTable ],

  methods:
  {
      fetch()
      {
          if (this.$route.params.id)
          {
            this.formEdit = true
            axios.get(process.env.API_URL + `/v1/admin/galleries/${this.$route.params.id}`).then(({ data }) => {
                this.model = data
            })

          } else {
              this.formEdit = false
              this.model = JSON.parse(JSON.stringify(this.emptyModel))
          }

      },

      closeForm()
      {
          this.$router.go(-1)
      }
  },

  data()
  {
        return {
            model: {},
            formEdit: false,
            url: '/v1/admin/galleries',
            tableName: 'tableGalleries',
            emptyModel: { title: null, images: [], slug: null, cover_id: null, is_published: false, videos: [], year: 2000, day: 1 },
        }
  }

}
</script>

<template>
<div class="panel panel-primary">
    <div class="panel-heading">
        <div>{{ $t('MENU.GALLERY') }}</div>
    </div>
    <div class="panel-body">
        <mv-gallery-form :model="model" :edit="formEdit" @save="saveForm"></mv-gallery-form>
    </div>
    <div class="panel-footer">
        <div class="text-right">
            <button class="btn btn-success" @click="$router.go(-1)">{{ $t('GENERAL.CANCEL') }}</button>
            <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/GalleryEditor.vue